export default __webpack_public_path__ + "banner-framework-abcc2eed.png";